import { render, staticRenderFns } from "./settleForm.vue?vue&type=template&id=f20def16&scoped=true&"
import script from "./settleForm.vue?vue&type=script&lang=js&"
export * from "./settleForm.vue?vue&type=script&lang=js&"
import style0 from "./settleForm.vue?vue&type=style&index=0&id=f20def16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20def16",
  null
  
)

export default component.exports